import  { useState,useContext, useEffect } from "react";
import VisitorContext from '../VisitorContext.jsx'
import editIcon from '../../../assets/edit.png'
import Popup from 'reactjs-popup';
import useSWR, { preload } from 'swr';
import { localAxios } from '../../../api';
import AddGuardianPopup from './AddGuardian.jsx';

 const EditPopup=({ item, trigger })=> {
    const { editVisitor, visitors, addNewVisitor, clearGuardianIfOrphaned, markGuardianMissing } = useContext(VisitorContext)
    const [error, setError] = useState(false);

    const [visitorFirstName, setVisitorFirstName] = useState(item.visitor_first_name);
    const [visitorLastName, setVisitorLastName] = useState(item.visitor_last_name);
    const [visitorOrgName, setVisitorOrgName] = useState(item.visitor_org_name);
    const [visitorIsMinor, setVisitorIsMinor] = useState(item.visitor_is_minor);
    const [personWillInviteOthers, setPersonWillInviteOthers] = useState(item.person_will_invite_others);
    const [personIsVisitor, setPersonIsVisitor] = useState(item.person_is_visitor ?? true);
    const [personIsGuardian, setPersonIsGuardian] = useState(false);

    const [visitorEmail, setVisitorEmail] = useState(item.visitor_email);
    const [visitorPhone, setVisitorPhone] = useState(item.visitor_phone);
    const [visitorDeadline, setVisitorDeadline] = useState(formatDateForInput(new Date(item.deadLine)));

    // this is the same as useDefaultValue
    const [userIsGuardian, setUserIsGuardian] = useState(item.user_is_guardian);

    // These are the states of the four input fields
    const [guardianFirstName, setGuardianFirstName] = useState(item.guardian_first_name);
    const [guardianLastName, setGuardianLastName] = useState(item.guardian_last_name);
    const [guardianEmail, setGuardianEmail] = useState(item.guardian_email);
    const [guardianPhone, setGuardianPhone] = useState(item.guardian_phone);
    const [selectedGuardianId, setSelectedGuardianId] = useState("");

    const { data, isLoading, isValidating, mutate } = useSWR('/api/me', localAxios) // undefined but loading even while page mounts


    const resetFields = (event) => {
        //Reset all fields so in the list of visitors, one does not have attributes that carry over.
        setVisitorFirstName("");
        setVisitorLastName("");
        setVisitorOrgName("");
        setVisitorIsMinor(false);
        setPersonWillInviteOthers(false);
        setPersonIsVisitor(true);
        setPersonIsGuardian(false);
        
        setVisitorEmail("");
        setVisitorPhone("");

        // this is the same as useDefaultValue
        setUserIsGuardian(false);

        // Guardian fields
        setGuardianFirstName("");
        setGuardianLastName("");
        setGuardianEmail("");
        setGuardianPhone("");
        setSelectedGuardianId("");
    }

    const handleCheckboxChange = (event) => {
        const isChecked = event.target.checked;
        setUserIsGuardian(isChecked);
    };

    const handleICheckboxChange = (event) => {
        const isChecked = event.target.checked;
        setPersonWillInviteOthers(isChecked);
    };
    
    const handleGCheckboxChange = (event) => {
        const isChecked = event.target.checked;
        setPersonIsGuardian(isChecked);
    };

    useEffect(() => {
        console.log('item.visitor_first_name is ',item.visitor_first_name);
    }, []);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setError(false);
        }, 1000);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [error]);

    useEffect(() => {
        
        // we are editing.  Simply load up all inputs if they have data
        setVisitorFirstName(item.visitor_first_name || '');
        setVisitorLastName(item.visitor_last_name || '');
        setVisitorOrgName(item.visitor_org_name || '');
        setVisitorIsMinor(item.visitor_is_minor || '');
        setPersonWillInviteOthers(item.person_will_invite_others || '');
        setPersonIsVisitor(item.person_is_visitor ?? true);
        setPersonIsGuardian(item.person_is_guardian || '');

        setVisitorEmail(item.visitor_email || '');
        setVisitorPhone(item.visitor_phone || '');
        setVisitorDeadline(formatDateForInput(new Date(item.deadLine)));

        // this is the same as useDefaultValue
        setUserIsGuardian(item.user_is_guardian || '');

        // These are the states of the four input fields
        setGuardianFirstName(item.guardian_first_name || '');
        setGuardianLastName(item.guardian_last_name || '');
        setGuardianEmail(item.guardian_email || '');
        setGuardianPhone(item.guardian_phone || '');

        if (item.visitor_is_minor && item.guardian_email) {
            const match = visitors.find(v => !v.visitor_is_minor && v.visitor_email === item.guardian_email);
            setSelectedGuardianId(match ? match.id : "");
        } else {
            setSelectedGuardianId("");
        }

    }, [item]); // An empty dependency array will run only once-- on mount


    function formatDateForInput(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    const handleGuardianSelected = (id) => {
        setSelectedGuardianId(id);
        if (!id) {
            setGuardianFirstName(""); setGuardianLastName("");
            setGuardianEmail(""); setGuardianPhone("");
            return;
        }
        const chosen = visitors.find(v => v.id === id);
        if (chosen) {
            setGuardianFirstName(chosen.visitor_first_name || "");
            setGuardianLastName(chosen.visitor_last_name || "");
            setGuardianEmail(chosen.visitor_email || "");
            setGuardianPhone(chosen.visitor_phone || "");
        }
    };

    const handleGuardianAdded = (newGuardian) => {
        addNewVisitor(newGuardian);
        setSelectedGuardianId(newGuardian.id);
        setGuardianFirstName(newGuardian.visitor_first_name || "");
        setGuardianLastName(newGuardian.visitor_last_name || "");
        setGuardianEmail(newGuardian.visitor_email || "");
        setGuardianPhone(newGuardian.visitor_phone || "");
    };

    function handleUpdate(close) {

        const currentDate = new Date();
        const deadlineDate = new Date();
        deadlineDate.setDate(currentDate.getDate() + 3); // Default deadline 72 hours from now
        const capitalizedF = visitorFirstName.charAt(0).toUpperCase() + visitorFirstName.slice(1);
        const capitalizedL = visitorLastName.charAt(0).toUpperCase() + visitorLastName.slice(1);
        const capitalizedO = visitorOrgName.charAt(0).toUpperCase() + visitorOrgName.slice(1);

        const effectiveEmail = visitorIsMinor ? '' : visitorEmail;
        const effectivePhone = visitorIsMinor ? '' : visitorPhone;

        const capitalizedGF = guardianFirstName.charAt(0).toUpperCase() + guardianFirstName.slice(1);
        const capitalizedGL = guardianLastName.charAt(0).toUpperCase() + guardianLastName.slice(1);

        const gEmailValidated = guardianEmail;
        const gPhoneValidated = guardianPhone;

        const newGuardianId = (visitorIsMinor && !userIsGuardian && selectedGuardianId) ? selectedGuardianId : "";
        const guardianNowResolved = !visitorIsMinor || userIsGuardian || !!newGuardianId;
        // Minors cannot be guardians, inviters, or visitors — override regardless of hidden checkbox state.
        const effectivePersonIsGuardian = visitorIsMinor ? false : personIsGuardian;
        const effectivePersonWillInviteOthers = visitorIsMinor ? false : personWillInviteOthers;
        const effectivePersonIsVisitor = visitorIsMinor ? false : personIsVisitor;

        editVisitor({
            ...item,
            visitor_first_name: capitalizedF,
            visitor_last_name: capitalizedL,
            visitor_org_name: capitalizedO,

            visitor_is_minor: visitorIsMinor,
            user_is_guardian: userIsGuardian,
            person_will_invite_others: effectivePersonWillInviteOthers,
            person_is_visitor: effectivePersonIsVisitor,
            person_is_guardian: effectivePersonIsGuardian,

            visitor_email: effectiveEmail,
            visitor_phone: effectivePhone,

            guardian_first_name: capitalizedGF,
            guardian_last_name: capitalizedGL,
            guardian_email: gEmailValidated,
            guardian_phone: gPhoneValidated,

            guardian_id: newGuardianId,
            guardian_missing: guardianNowResolved ? false : (item.guardian_missing ?? false),

            deadLine: new Date(visitorDeadline),
            completed: false,
        });

        // If the old guardian is being replaced or the person is no longer a minor,
        // remove their guardian badge if no other minors still reference them.
        const oldGuardianId = item.guardian_id;
        const guardianChanged = newGuardianId !== oldGuardianId;
        const noLongerMinor = item.visitor_is_minor && !visitorIsMinor;
        if (oldGuardianId && (guardianChanged || noLongerMinor)) {
            clearGuardianIfOrphaned(oldGuardianId, item.id);
        }

        // If this person was a guardian and is no longer one (including being made a minor),
        // disassociate all minors that still reference them.
        if (item.person_is_guardian && !effectivePersonIsGuardian) {
            markGuardianMissing(item.id);
        }

        // Add badge to the newly selected guardian (if applicable).
        if (visitorIsMinor && selectedGuardianId && !userIsGuardian) {
            const guardian = visitors.find(v => v.id === selectedGuardianId);
            if (guardian) {
                editVisitor({ ...guardian, person_is_guardian: true });
            }
        }

        setError(false);
        resetFields();
        close();
    }

    return (
        <Popup trigger={trigger ?? <img src={editIcon} />} modal nested >
            {close => (
                
                <div className="floatBody">
                    <div className="floatSignupForm" >
                        <form action="" className="floatForm">
                            <div className="float-header">Edit person</div>

                            <div className="float-main">
                                <div className="floatInputContainer">
                                    <input
                                        className="floatInput"
                                        placeholder="a"
                                        type="text"
                                        id="visitorFirstName"
                                        value={visitorFirstName}
                                        onChange={(e) => setVisitorFirstName(e.target.value)}
                                    />
                                    <label htmlFor="visitorFirstName" className="floatLabel">First Name:</label>
                                </div>
                            
                                <div className="floatInputContainer">
                                    <input
                                        className="floatInput"
                                        placeholder="a"
                                        type="text"
                                        id="visitorLastName"
                                        value={visitorLastName}
                                        onChange={(e) => setVisitorLastName(e.target.value)}
                                    />
                                    <label htmlFor="visitorLastName" className="floatLabel">Last Name:</label>
                                </div>

                                <div className="floatInputContainer">
                                    <input
                                        className="floatInput"
                                        placeholder="a"
                                        type="text"
                                        id="visitorOrgName"
                                        value={visitorOrgName}
                                        onChange={(e) => setVisitorOrgName(e.target.value)}
                                    />
                                    <label htmlFor="visitorOrgName" className="floatLabel">Organization:</label>
                                </div>

                                <div className="formCheckBox">
                                    <label htmlFor="visitorIsMinor">This person is under 18:</label>
                                    <input
                                        type="checkbox"
                                        id="visitorIsMinor"
                                        checked={visitorIsMinor}
                                        onChange={(e) => setVisitorIsMinor(e.target.checked)}
                                    />
                                </div>


                                {
                                    visitorIsMinor ? (

                                        <>

                                                <div className="formCheckBox">
                                                    <label htmlFor="userIsGuardian">I am the guardian:</label>
                                                    <input
                                                        type="checkbox"
                                                        id="userIsGuardian"
                                                        checked={userIsGuardian}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                </div>

                                                <p>Parent / Guardian</p>

                                                {userIsGuardian ? (
                                                    <p style={{ fontSize: '14px', color: '#555' }}>
                                                        Guardian set to: {guardianFirstName} {guardianLastName}
                                                    </p>
                                                ) : (
                                                    <>
                                                        <div className="floatInputContainer">
                                                            <select
                                                                id="guardianSelect"
                                                                value={selectedGuardianId}
                                                                onChange={(e) => handleGuardianSelected(e.target.value)}
                                                                className="floatInput"
                                                                style={{ paddingTop: '8px' }}
                                                            >
                                                                <option value="">-- Select Guardian --</option>
                                                                {visitors
                                                                    .filter(v => !v.visitor_is_minor && v.id !== item.id)
                                                                    .map(v => (
                                                                        <option key={v.id} value={v.id}>
                                                                            {v.visitor_first_name} {v.visitor_last_name}
                                                                        </option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>

                                                        <AddGuardianPopup onGuardianAdded={handleGuardianAdded} />
                                                    </>
                                                )}

                                            </>
                                        
                                        ) : (

                                            <>

                                                <div className="formCheckBox">
                                                    <label htmlFor="personIsVisitor">This person is a visitor</label>
                                                    <input
                                                        type="checkbox"
                                                        id="personIsVisitor"
                                                        checked={personIsVisitor}
                                                        onChange={(e) => setPersonIsVisitor(e.target.checked)}
                                                    />
                                                </div>

                                                <div className="formCheckBox">
                                                    <label htmlFor="personIsGuardian">This person is a guardian</label>
                                                    <input
                                                        type="checkbox"
                                                        id="personIsGuardian"
                                                        checked={personIsGuardian}
                                                        onChange={handleGCheckboxChange}
                                                    />
                                                </div>

                                                <div className="formCheckBox">
                                                    <label htmlFor="personWillInviteOthers">He/she will invite others:</label>
                                                    <input
                                                        type="checkbox"
                                                        id="personWillInviteOthers"
                                                        checked={personWillInviteOthers}
                                                        onChange={handleICheckboxChange}
                                                    />
                                                </div>

                                                <div className="floatInputContainer">
                                                    <input
                                                        className="floatInput"
                                                        placeholder="a"
                                                        type="text"
                                                        id="visitorEmail"
                                                        value={visitorEmail}
                                                        onChange={(e) => setVisitorEmail(e.target.value)}
                                                    />
                                                    <label htmlFor="visitorEmail" className="floatLabel">Email:</label>
                                                </div>

                                                <div className="floatInputContainer">
                                                    <input
                                                        className="floatInput"
                                                        placeholder="a"
                                                        type="text"
                                                        id="visitorPhone"
                                                        value={visitorPhone}
                                                        onChange={(e) => setVisitorPhone(e.target.value)}
                                                    />
                                                    <label htmlFor="visitorPhone" className="floatLabel">Phone:</label>
                                                </div>
                                    
                                        </>
                                    )
                                }

                            </div>

                            <div className="float-footer">
                                <div className="formButtons">
                                    <button className="button save" onClick={() => handleUpdate(close)}>Save</button>
                                    <button className="button cancel"
                                        onClick={() => { close(); }}>Cancel</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                
            )}
        </Popup>
    )
}

export default EditPopup;